module.exports = __webpack_public_path__ + "static/img/1070_phase_function_Paper_PointsHejduk_Prediction.6e35d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1070_phase_function_Paper_PointsHejduk_Prediction.png
// module id = vXH6
// module chunks = 0